import { Button } from '@/components/ui/button';

export function C2AskShareTools({
  onYes,
  onNo,
}: {
  onYes: () => void;
  onNo: () => void;
}) {
  return (
    <div className="h-full flex flex-col bg-white p-6 rounded-lg shadow-sm border border-[#D6D6D6]">
      <div className="flex-1 flex flex-col items-center justify-center space-y-6">
        <div className="text-center space-y-3">
          <h3 className="text-lg font-semibold">Share Tool Data?</h3>
          <p className="text-sm text-muted-foreground max-w-md">
            Does any other gcode share the same tools data?
          </p>
        </div>

        <div className="flex gap-4 w-full max-w-sm">
          <Button variant="outline" className="flex-1" onClick={onNo}>
            No
          </Button>
          <Button className="flex-1" onClick={onYes}>
            Yes
          </Button>
        </div>
      </div>
    </div>
  );
}

export default C2AskShareTools;
